import React from "react";
import { Download } from "lucide-react";
import { downloadFile } from "../../lib/downloadFile";

export default function VideoPlayer({ src, name }) {
  return (
    <div className="bg-black border border-white/5 rounded-xl overflow-hidden">
      <video src={src} controls className="w-full max-h-[480px] bg-black" preload="metadata">
        Your browser does not support video playback.
      </video>
      <div className="flex items-center justify-between gap-2 px-3 py-2">
        {name ? (
          <div className="text-xs text-white/60 truncate flex-1">{name}</div>
        ) : (
          <div className="flex-1" />
        )}
        <button
          type="button"
          onClick={() => downloadFile(src, name)}
          data-testid="video-download-btn"
          className="flex-shrink-0 w-8 h-8 rounded-full border border-white/15 flex items-center justify-center text-white/70 hover:text-paul-yellow hover:border-paul-yellow transition-colors"
          aria-label="Download video"
          title="Download"
        >
          <Download className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
